import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { ExchangeCodeRequest } from '../../models/exchangeCode';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tiktok-callback',
  imports: [CommonModule],
  templateUrl: './tiktok-callback.component.html',
  styleUrl: './tiktok-callback.component.css'
})
export class TiktokCallbackComponent implements OnInit {

  message: string = 'Loading...';
  message2: string = '';

  constructor(private loginService: LoginService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const scope = params['scope'];
      // const state = params['state'];
      const error = params['error'];
      const errorType = params['error_type'];
      const expectedState = localStorage.getItem('tiktok_oauth_state');

      if (error || errorType) {
        this.message = `TikTok authorization failed: ${errorType || error}`;
        return;
      }

      // if (!state || state !== expectedState) {
      //   this.message = 'TikTok authorization failed: invalid state.';
      //   return;
      // }

      if (!code) {
        this.message = 'TikTok authorization failed: missing code.';
        return;
      }

      var exchangeCodeRequest: ExchangeCodeRequest = {
        code: code,
        scopes: scope,
        redirectUri: environment.tiktokCallbackUri
      };

      this.loginService.exchangeCode(exchangeCodeRequest).subscribe({
        next: () => {
          console.log('Exchange code successful');
          this.message = 'Thank you! Your TikTok account is now connected.';
          localStorage.removeItem('tiktok_oauth_state');

        },
        error: (err) => {
          console.log(err);
          this.message = 'TikTok authorization failed. Please try again.';
        }
      })
    });

  }

}
